import { render, staticRenderFns } from "./CreateRedeem.vue?vue&type=template&id=270a8052"
import script from "./CreateRedeem.vue?vue&type=script&lang=js"
export * from "./CreateRedeem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports